<template>
  <div class="map-page">
    <Form ref="editForm" :label-width="100" :model="formData" inline>
      <FormItem label="站点名称" prop="gas_name">
        <Input v-model="formData.gas_name" placeholder=""></Input>
      </FormItem>
      <FormItem label="站点地址" prop="gas_address">
        <Input v-model="formData.gas_address" placeholder=""></Input>
      </FormItem>
      <FormItem label="站点类型" prop="station_type">
        <Select v-model="formData.station_type" placeholder="站点类型">
          <Option value="">全部站点</Option>
          <Option v-for="(item,key) in station_types" :key="key" :value="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="站点渠道" prop="platform">
        <Select v-model="formData.platform" placeholder="渠道">
          <Option value="">全部</Option>
          <Option v-for="(item,key) in platform"  :key="key" :value="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="getStations">确定</Button>
      <FormItem label="地址定位" prop="nearbyAddress">
        <Input v-model="nearbyAddress" :placeholder="'输入真实地址，查找周边' + nearbyRadiusKm + '公里油站'"></Input>
      </FormItem>
      <FormItem label="匹配范围" prop="nearbyRadius">
        <InputNumber v-model="nearbyRadius" :min="1" :max="50" :step="1" style="width: 120px"></InputNumber>
        <span style="margin-left: 6px">公里</span>
      </FormItem>
      <Button type="success" @click="searchByAmap">地址搜索</Button>
    </Form>

    <div class="map-wrap" :style="{height: mapHeight + 'px'}">
      <div class="map-pane">
        <div class="map-title">我们的站点</div>
        <div id="mapLeft" class="map-box"></div>
      </div>
      <div class="map-pane">
        <div class="map-title">地址搜索（高德）</div>
        <div id="mapRight" class="map-box"></div>
      </div>
    </div>
  </div>
</template>

<script>
  //高德 JSAPI 2.0 安全密钥：Geocoder/PlaceSearch 等服务接口必需（与 upload.vue 保持一致）
  window._AMapSecurityConfig = {
    securityJsCode: "20341665b1257613258851e2f4d03f9b"
  };
  import AMapLoader from '@amap/amap-jsapi-loader';
  export default {
    name: "mapStation",
    data() {
      return {
        formData:{
          gas_name:'',
          gas_address:'',
          station_type:'',
          platform:''
        },
        station_types:[],
        platform:[],
        nearbyAddress:'',
        //周边匹配范围（公里），由用户输入，默认 6
        nearbyRadius: 6,
        mapHeight: 500
      }

    },
    computed: {
      //匹配范围兜底：输入被清空或填 0 时按 6 公里，上限 50 公里（后端 radius<=0 会不做半径过滤而返回全量站点）
      nearbyRadiusKm(){
        let r = Number(this.nearbyRadius);
        if (!(r > 0)) return 6;
        return r > 50 ? 50 : r;
      }
    },
    methods: {
      // 根据屏幕高度动态计算地图容器高度：视口高度 - 容器顶部位置 - 底部留白
      calcMapHeight(){
        const el = document.querySelector('.map-wrap');
        if (!el) return;
        const top = el.getBoundingClientRect().top;
        const height = window.innerHeight - top - 20;
        this.mapHeight = height > 300 ? height : 300;
        this.$nextTick(() => {
          [this.mapLeft, this.mapRight].forEach((m) => {
            if (m && typeof m.resize === 'function') m.resize();
          });
        });
      },
      async initMap(){
        AMapLoader.load({
          key:"c3219f1ed0f4493a4f3ca6ead5e51d37",     // 申请好的Web端开发者Key，首次调用 load 时必填
          version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins:['AMap.LabelsLayer','AMap.LabelMarker','AMap.MarkerCluster','AMap.Geocoder','AMap.PlaceSearch'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap)=>{
          this.AMap = AMap;
          //左右两个地图：左侧展示我们的站点，右侧展示高德地址搜索结果
          let baseOpt = { zoom: 5, center: [108.55, 34.32] };
          this.mapLeft = new AMap.Map("mapLeft", baseOpt);
          this.mapRight = new AMap.Map("mapRight", baseOpt);
          this.labelsLayer = new this.AMap.LabelsLayer({
            zooms: [3, 20],
            zIndex: 1000,
            // 该层内标注是否避让（仅用于车辆等少量标注）
            collision: true,
            // 设置 allowCollision：true，可以让标注避让用户的标注
            allowCollision: true,
          });
          //联动：移动/缩放任意一侧，另一侧同步中心点与级别
          this.bindMapSync();
          this.getStations()
        }).catch(e=>{
          console.log(e);
        })
      },
      //绑定左右地图联动：任一侧 moveend/zoomend 后把中心点和缩放同步到另一侧（加锁防止互相触发死循环）
      bindMapSync(){
        let syncing = false;
        const link = (from, to) => {
          if (syncing) return;
          syncing = true;
          to.setZoomAndCenter(from.getZoom(), from.getCenter());
          setTimeout(() => { syncing = false; }, 100);
        };
        this.mapLeft.on('moveend', () => link(this.mapLeft, this.mapRight));
        this.mapLeft.on('zoomend', () => link(this.mapLeft, this.mapRight));
        this.mapRight.on('moveend', () => link(this.mapRight, this.mapLeft));
        this.mapRight.on('zoomend', () => link(this.mapRight, this.mapLeft));
      },
      async getStations(){

        //先清空车辆标注
        this.labelsLayer.clear();

        //确定按钮：只走数据库查询，结果渲染到左侧地图，并清除高德定位标记（两侧红点，与地址搜索分开）
        if (this.searchMarker){ this.mapRight.remove(this.searchMarker); this.searchMarker = null; }
        if (this.searchMarkerLeft){ this.mapLeft.remove(this.searchMarkerLeft); this.searchMarkerLeft = null; }

        let stations = await this.$commonFun.postProxy('admin/gas/getMapStations',this.formData)
        if(!stations.data)  return  false;

        //站点：使用点聚合(MarkerCluster)展示，密集区域按数量聚合、放大后散开，避免互相遮挡
        let points = [];
        let stationData = stations.data.stations.map((item)=>{
          let lng = parseFloat(item.longitude);
          let lat = parseFloat(item.latitude);
          points.push([lng, lat]);
          return { lnglat: [lng, lat], weight: 1, station: item };
        });
        this.renderStationCluster(stationData, 'left');

        stations.data.cars.forEach((item)=>{
          let icon = {
            type: 'image',
            image: item.icon,
            size: [30, 30],
            anchor: 'center',
          }, text = {
            content: item.car_number,
            direction: 'right',
            offset: [-5, -5],
            style: {
              fontSize: 12,
              fillColor: '#1e2696',
              strokeColor: '#fff',
              strokeWidth: 2,
            }
          };
          let labelMarker = new this.AMap.LabelMarker({
            name: item.gas_name, // 此属性非绘制文字内容，仅最为标识使用
            position: [item.longitude, item.latitude],
            zIndex: 16,
            icon: icon,
            text: text,
          });
          labelMarker.on("click",()=>{
            this.showObdInfo(item)
          })
          this.labelsLayer.add(labelMarker)
        })
        this.mapLeft.add(this.labelsLayer);

        //把地图视野贴合到站点分布范围
        if (points.length) {
          let lngs = points.map(p => p[0]);
          let lats = points.map(p => p[1]);
          let southWest = [Math.min.apply(null, lngs), Math.min.apply(null, lats)];
          let northEast = [Math.max.apply(null, lngs), Math.max.apply(null, lats)];
          this.mapLeft.setBounds(new this.AMap.Bounds(southWest, northEast), false, [40, 40, 40, 40], 13);
        }
      },
      //地址定位（高德）：解析地址→搜索周边真实加油站→展示到右侧地图，全程不请求我们数据库
      async searchByAmap(){
        if (!this.nearbyAddress){
          this.$Message.warning('请先输入地址');
          return;
        }
        //解析中心点：结构化地址(含省市区/路街道/号)优先用 Geocoder，像店名/POI 名称的用 PlaceSearch 关键字，二者互为兜底
        let isStructured = /[省市区县路街道村镇号]/.test(this.nearbyAddress) && this.nearbyAddress.length >= 8;
        let center = null;
        if (isStructured){
          center = await this.geocodeAddress(this.nearbyAddress);
          if (!center) center = await this.locateByPoi(this.nearbyAddress);
        }else{
          center = await this.locateByPoi(this.nearbyAddress);
          if (!center) center = await this.geocodeAddress(this.nearbyAddress);
        }
        if (!center){
          this.$Message && this.$Message.warning('未能定位该地址，请检查输入内容');
          return;
        }
        let pois = await this.searchNearbyGas(center, this.nearbyRadiusKm * 1000);
        let icon = 'https://oil.scsasy.com/static/images/icon/oil_station.png';
        let data = pois.map((poi)=>{
          let lng = poi.location.getLng();
          let lat = poi.location.getLat();
          let dist = this.distanceInKm(center, [lng, lat]);
          return { lnglat: [lng, lat], weight: 1, station: {
            gas_name: poi.name,
            gas_address: poi.address || this.nearbyAddress,
            longitude: lng,
            latitude: lat,
            icon: icon,
            distance: dist,
          }};
        });
        //高德不回传距离，按中心点算出的距离从近到远排序
        data.sort((a, b)=> a.station.distance - b.station.distance);
        this.renderStationCluster(data, 'right');
        this.showSearchCenter(center, 'right');
        //同时用这个地址中心点，在我们站点（左侧）中筛选该匹配范围内的站点展示
        this.renderNearbyStations(center);
        this.mapRight.setZoomAndCenter(13, center);
        if (!data.length){
          this.$Message && this.$Message.info('该地址周边' + this.nearbyRadiusKm + '公里内未找到加油站');
        }
      },
      //按已解析的地址中心点，交由后端按中心点+半径（公里）过滤我们数据库的周边站点，渲染到左侧地图
      async renderNearbyStations(center){
        let params = Object.assign({}, this.formData, {
          center_lng: center[0],
          center_lat: center[1],
          radius: this.nearbyRadiusKm,
        });
        let stations = await this.$commonFun.postProxy('admin/gas/getMapStations', params);
        if (!stations.data || !stations.data.stations) return;
        let near = stations.data.stations.map((item)=>{
          let lng = parseFloat(item.longitude);
          let lat = parseFloat(item.latitude);
          //计算该站点到搜索中心点的距离（公里），附到站点数据上供信息窗体展示
          item.distance = this.distanceInKm(center, [lng, lat]);
          return { lnglat: [lng, lat], weight: 1, station: item };
        });
        //左侧只聚焦展示该地址附近的我们的站点，清掉车辆标注避免干扰
        this.labelsLayer.clear();
        this.renderStationCluster(near, 'left');
        this.showSearchCenter(center, 'left');
        if (!near.length){
          this.$Message && this.$Message.info('该地址周边' + this.nearbyRadiusKm + '公里内暂无我们的站点');
        }
      },
      //用高德 PlaceSearch 搜索中心点周边 radius 米内的加油站，返回 POI 数组
      searchNearbyGas(center, radius){
        return new Promise((resolve)=>{
          if (!this.placeSearch){
            this.placeSearch = new this.AMap.PlaceSearch({
              pageSize: 50,
              pageIndex: 1,
              extensions: 'all',
            });
          }
          this.placeSearch.searchNearBy('加油站', center, radius, (status, result)=>{
            if (status === 'complete' && result.poiList && result.poiList.pois){
              resolve(result.poiList.pois);
            }else{
              console.warn('高德周边搜索失败:', status, result);
              resolve([]);
            }
          });
        });
      },
      //把地址文本解析为真实经纬度坐标 [lng, lat]，失败返回 null（不传 city，缺省即全国检索）
      geocodeAddress(address){
        return new Promise((resolve)=>{
          if (!this.geocoder){
            this.geocoder = new this.AMap.Geocoder();
          }
          this.geocoder.getLocation(address, (status, result)=>{
            if (status === 'complete' && result.geocodes && result.geocodes.length){
              let loc = result.geocodes[0].location;
              resolve([loc.getLng(), loc.getLat()]);
            }else{
              console.warn('高德地址解析失败:', status, result);
              resolve(null);
            }
          });
        });
      },
      //用 PlaceSearch 按关键字定位地址（默认全国检索，对模糊地址更宽容），失败返回 null
      locateByPoi(keyword){
        return new Promise((resolve)=>{
          if (!this.placeSearch){
            this.placeSearch = new this.AMap.PlaceSearch({
              pageSize: 50,
              pageIndex: 1,
              extensions: 'all',
            });
          }
          this.placeSearch.search(keyword, (status, result)=>{
            if (status === 'complete' && result.poiList && result.poiList.pois && result.poiList.pois.length){
              let loc = result.poiList.pois[0].location;
              resolve([loc.getLng(), loc.getLat()]);
            }else{
              console.warn('高德地址POI定位失败:', status, result);
              resolve(null);
            }
          });
        });
      },
      //两点间球面距离（公里）
      distanceInKm(p1, p2){
        const R = 6371;
        const toRad = d => d * Math.PI / 180;
        let dLat = toRad(p2[1] - p1[1]);
        let dLng = toRad(p2[0] - p1[0]);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
          + Math.cos(toRad(p1[1])) * Math.cos(toRad(p2[1]))
          * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 2 * R * Math.asin(Math.sqrt(a));
      },
      //在指定侧地图（默认右侧）上标记搜索到的地址位置
      showSearchCenter(center, side){
        let map = side === 'left' ? this.mapLeft : this.mapRight;
        let key = side === 'left' ? 'searchMarkerLeft' : 'searchMarker';
        if (this[key]){ map.remove(this[key]); }
        this[key] = new this.AMap.Marker({
          position: center,
          content: '<div style="width:16px;height:16px;border-radius:50%;background:#e53935;border:3px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>',
          offset: new this.AMap.Pixel(-8, -8),
          zIndex: 200,
          title: '搜索地址',
          //点击穿透：避免红点盖住下方站点图标导致站点无法点击
          bubble: true,
        });
        //红点不是站点，点击时展示搜索到的地址信息
        this[key].on('click', ()=>{
          let infoWindow = new this.AMap.InfoWindow({
            anchor: 'top',
            offset: [15, -10],
            content: '<div><b>搜索地址</b><br/><span>' + this.nearbyAddress + '</span><br/></div>',
          });
          infoWindow.open(map, center);
        });
        map.add(this[key]);
      },
      //渲染/更新站点聚合：首次创建 MarkerCluster，之后用 setData 更新数据
      //side='left' 渲染到左侧（我们的站点），side='right' 渲染到右侧（高德搜索结果）
      renderStationCluster(data, side){
        let map = side === 'right' ? this.mapRight : this.mapLeft;
        let key = side === 'right' ? 'clusterRight' : 'clusterLeft';
        if (this[key]){
          this[key].setData(data);
          return;
        }
        this[key] = new this.AMap.MarkerCluster(map, data, {
          gridSize: 60,
          maxZoom: 12,
          //单个站点：直接展示站点图标，并在真正渲染出的 marker 上绑定点击（聚合内部会占用 extData，故用自定义属性存站点）
          renderMarker: (ctx)=>{
            let item = ctx.data[0].station;
            ctx.marker.setContent('<img src="' + item.icon + '" style="width:30px;height:30px;display:block"/>');
            ctx.marker.setOffset(new this.AMap.Pixel(-15, -15));
            ctx.marker.__station = item;
            if (!ctx.marker.__clickBound){
              ctx.marker.__clickBound = true;
              ctx.marker.on('click', ()=>{
                if (ctx.marker.__station) this.openInfoWindow(ctx.marker.__station, map);
              });
            }
          },
          //聚合点：展示数量气泡（点击默认放大展开）
          renderCluster: (ctx)=>{
            ctx.marker.setContent('<div style="background:#1e88e5;color:#fff;width:40px;height:40px;line-height:40px;text-align:center;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.3)">' + ctx.count + '</div>');
            ctx.marker.setOffset(new this.AMap.Pixel(-20, -20));
          },
        });
      },
      openInfoWindow(item, map){
        //距离：按地址中心点算出的到搜索地址的距离（左侧我们的站点、右侧高德 POI 均会展示）
        let distHtml = '';
        if (item.distance !== undefined && item.distance !== null){
          distHtml = `<span style="color:#1e88e5">距离：${item.distance.toFixed(2)} 公里</span><br/>`;
        }
        //价格：油机价(price)、挂牌价(ndrc_price)，仅我们的站点（数据库）才有，哪个为空就不展示哪行
        let hasPrice = (v) => (v !== undefined && v !== null && v !== '');
        let priceHtml = '';
        if (hasPrice(item.price)){
          priceHtml += `<span style="color:#e53935">油机价：${item.price} 元/L</span><br/>`;
        }
        if (hasPrice(item.ndrc_price)){
          priceHtml += `<span style="color:#e53935">挂牌价：${item.ndrc_price} 元/L</span><br/>`;
        }
        let content = [
          '<div>',
          `<b>${item.gas_name}</b><br/>`,
          `<span>${item.gas_address}</span><br/>`,
          distHtml,
          priceHtml,
          '</div>'
      ];
      // 创建 infoWindow 实例
        let infoWindow = new this.AMap.InfoWindow({
          anchor: 'top',
          offset:[15,-10],
          content: content.join("")  //传入 dom 对象，或者 html 字符串
        });
        // 打开信息窗体（在触发点击的那侧地图上打开）
        infoWindow.open(map || this.mapLeft, [item.longitude, item.latitude]);
      },
      showObdInfo(item){
        let content = [
          '<div>',
          `<b>车牌:${item.car_number}</b><br/>`,
          `<span>地址:${item.address}</span><br/>`,
          `<span>车速:${item.speed}</span><br/>`,
          `<span>时间:${item.server_date}</span><br/>`,
          '</div>'
        ];
        // 创建 infoWindow 实例
        let infoWindow = new this.AMap.InfoWindow({
          anchor: 'top',
          offset:[15,-10],
          content: content.join("")  //传入 dom 对象，或者 html 字符串
        });
        // 打开信息窗体
        infoWindow.open(this.mapLeft,[item.longitude, item.latitude]);
      },
      async initPage(){
        let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['stationType','platform']})
        this.station_types = data.data.stationType
        this.platform = data.data.platform
        this.formData.station_type = 'oil_station'
      }
    },
    mounted() {
      this.initPage();
      this.initMap();
      this.$nextTick(() => {
        this.calcMapHeight();
      });
      window.addEventListener('resize', this.calcMapHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.calcMapHeight);
    },
  }
</script>

<style scoped>
  .map-wrap{
    display: flex;
    gap: 8px;
    width: 100%;
  }
  .map-pane{
    flex: 1;
    min-width: 0;
    position: relative;
  }
  .map-title{
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 5;
    background: rgba(255, 255, 255, .9);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 13px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, .2);
  }
  .map-box{
    width: 100%;
    height: 100%;
    border: 1px solid #e8eaec;
    border-radius: 4px;
  }
</style>
